import { render, staticRenderFns } from "./AuthorityManage.vue?vue&type=template&id=70097b2a&scoped=true&"
import script from "./AuthorityManage.vue?vue&type=script&lang=js&"
export * from "./AuthorityManage.vue?vue&type=script&lang=js&"
import style0 from "./AuthorityManage.vue?vue&type=style&index=0&id=70097b2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70097b2a",
  null
  
)

export default component.exports